import React from 'react';
import styled from 'styled-components';
import { FONT } from '../../styles/color';

const ButtonsWrapper = styled.div`
	display: grid;
	width: ${(props) => props.$width ? props.$width : '100%' };
	height: ${(props) => props.$height};
	grid-template-columns: repeat(${ (props) => props.$number }, 1fr);
	grid-template-rows: 1fr;
	background-color: ${ FONT.light01 };
	gap: 1px;
	border-radius: 4px;
	overflow: hidden;
`;

const Button = styled.button`
	background-color: ${ FONT.default };
	border: none;
	color: ${ FONT.light01 };
	font-family: Pretendard Variable;
	font-weight: 500;
	font-size: 18px;
	cursor: pointer;
`;

export default function Buttons(props) {
	return (
		<ButtonsWrapper $number={ props.button.length } $height={ props.height }>
			{
				props.button.map((button, index) => (
					<Button key={ index } onClick={button.onClick}>{button.text}</Button>
				))	
			}
		</ButtonsWrapper>
	)
}
